import { IconAlertTriangle } from '@iwoca/icons';
import { AlertBox, Button } from '@iwoca/orion';

import { OngoingPaymentPlan } from '../../Dashboard.types';
import { formatCurrency } from '../../utils/currency';

export const RepayRequest = ({
  paymentPlan,
}: {
  paymentPlan: OngoingPaymentPlan;
}) => {
  const account = paymentPlan.account;
  const accountId = account.account_id;

  const nextRepaymentAmount =
    account.scheduled_payments?.summary?.simplified_schedule?.next_repayment
      ?.amount ??
    account.scheduled_payments?.summary?.simplified_schedule?.equal_repayments
      ?.amount;

  return (
    <AlertBox
      variant="failure"
      className="mb-l flex flex-col items-start gap-m !bg-structure-100 !p-l"
      data-testid="overdue-repay-request-section"
    >
      <div
        data-testid="overdue-repay-request-explanation"
        className="flex flex-col gap-m"
      >
        <div className="flex items-center gap-s">
          <IconAlertTriangle className="h-[20px] w-[20px] fill-[#FB5950]" />
          <p className="m-0 text-xl font-bold">
            You have an overdue payment on this payment plan
          </p>
        </div>
        {nextRepaymentAmount !== undefined ? (
          <p className="m-0 text-m font-med">
            You have an overdue payment of{' '}
            <span>{formatCurrency(nextRepaymentAmount)}</span>. Please make a
            payment or get in touch with us.
          </p>
        ) : (
          <p className="m-0 text-m font-med">
            Something went wrong. Please try again later.
          </p>
        )}
      </div>

      <a href={`/pay/repayment/choose-amount/?accountId=${accountId}`}>
        <Button type="button" data-testid="overdue-repay-request-cta">
          Pay now
        </Button>
      </a>
    </AlertBox>
  );
};
